import React, { useEffect, useState } from "react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Grid from "@mui/material/Grid2";
import Avatar from "@mui/material/Avatar";
import { menuTitles } from "../../constants/menus";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { getUserById } from "../../services/user.service";
// import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import NoProfile from "../../assets/images/No_Profile.svg";
import { getClientById } from "../../services/client.service";
import { useAuth } from "../../context/AuthProvider";
import { decryptData } from "../../utils/cryptoUtils";
import Notification from "./Notification/Notification";
import { ROLE_LABELS, ROLES } from "../../utils/roles";

const Header = ({ onOpenSidebar }) => {
  const [title, setTitle] = React.useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [roleName, setRole] = useState("Employee");
  const [decodedToken, setDecodedToken] = useState("");
  const [fullName, setFullName] = useState("");
  const [userId, setUserId] = useState();


  React.useEffect(() => {
    const currentPage = location.pathname?.split("/")[2] || "";
    const fallbackTitle = currentPage
      ? currentPage
          .replace(/-/g, " ")
          .replace(/([a-z])([A-Z])/g, "$1 $2")
          .split(" ")
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(" ")
      : "";
    setTitle(menuTitles[currentPage] || fallbackTitle);
  }, [location.pathname]);

  const userName = localStorage.getItem("userName");

  const Admin = localStorage.getItem("isOverAllAdmin");
  const Client = localStorage.getItem("isClient");
  // const token = localStorage.getItem("token");
  const { accessToken } = useAuth();

  const getUserData = async () => {
    try {
      if (userId) {
        const res = await getUserById(userId);
        const userData = res.data.data;
        setData(userData);
        setRole(ROLE_LABELS[userData?.role] || "");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const decodeToken = () => {
    if (accessToken) {
      const decoded = jwtDecode(accessToken);
      setDecodedToken(decoded);
      // const fullName = `${decoded.firstname || ""} ${
      //   decoded.lastname || ""
      // }`.trim();
      const fullName = decryptData(decoded?.name);
      setUserId(decoded?.id);
      setFullName(fullName);
    }
  };
  const getClientData = async () => {
    try {
      const userId = decodedToken?.id;
      const res = await getClientById(userId);
      const clientData =
        Array.isArray(res.data.data) && res.data.data.length > 0
          ? res.data.data[0]
          : {};
      setData(clientData);
      setRole(clientData?.role === 3 ? "Client" : "");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    decodeToken();
    // if (role === 3) {
    //   getClientData();
    // } else {
    //   getUserData();
    // }
  }, [accessToken]);

  useEffect(() => {
    if (decodedToken) {
      const userRole = decodedToken?.role;
      if (userRole === 3) {
        getClientData();
      }
      getUserData();
    }
  }, [decodedToken, userId]);


  const renderFile = (file) => {
    if (!file?.location)
      return (
        <span
          style={{ cursor: "pointer", fontSize: "16px", fontWeight: 600 }}
          onClick={async () => {
            if (userId) {
              const res = await getUserById(userId);
              if (res.data) {
                navigate("/home/employeeDetails", {
                  state: { selectedData: res.data.data },
                });
              }
            }
          }}
        >
          {fullName.charAt(0).toUpperCase()}
        </span>
      );

    return (
      <img
        src={file.location}
        alt={file.fileName || "No Profile"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          cursor:
            (roleName === "Employee" || roleName === "Admin") && "pointer",
        }}
        onClick={async () => {
          if (userId) {
            const res = await getUserById(userId);
            if (res.data) {
              navigate("/home/employeeDetails", {
                state: { selectedData: res.data.data },
              });
            }
          }
        }}
      />
    );
  };

  // useEffect(() => {
  //   const Admin = localStorage.getItem("isOverAllAdmin") === "true";
  //   const Client = localStorage.getItem("isClient") === "true";
  //   if (Admin && Client) {
  //     setRole("Admin and Client");
  //   } else if (Admin) {
  //     setRole("Admin");
  //   } else if (Client) {
  //     setRole("Client");
  //   } else {
  //     setRole("Employee");
  //   }
  // }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        // height: "50px",
        paddingLeft: { xs: "32px", md: 0 },
        background: "#FFF;",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {onOpenSidebar && (
          <Tooltip title="Open sidebar" placement="right" arrow>
            <IconButton
              onClick={onOpenSidebar}
              size="small"
              sx={{
                color: "#008080",
                background: "linear-gradient(135deg, rgba(0,128,128,0.10) 0%, rgba(0,184,184,0.08) 100%)",
                border: "1px solid rgba(0,128,128,0.2)",
                borderRadius: "8px",
                "&:hover": {
                  background: "linear-gradient(135deg, rgba(0,128,128,0.18) 0%, rgba(0,184,184,0.14) 100%)",
                },
              }}
            >
              <ChevronRightIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        <Typography
          sx={{
            color: "#3D3D3D",
            fontWeight: { xs: 500, md: 700 },
            fontSize: { xs: "12px", md: "16px" },
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: { xs: "220px", sm: "300px", md: "100%" },
          }}
        >
          {title}
        </Typography>
      </Box>
      <Grid
        sx={{
          paddingRight: { xs: "10px", md: "20px" },
          display: "flex",
          alignItems: "center",
          gap: { xs: "5px", md: "15px" },
        }}
      >

        {/* Org Admin has no todo-task access (the bell reads /getTodoTask, which
            the backend refuses for role 7), so the bell is hidden rather than
            left to fail. */}
        {roleName !== "Client" && !data?.orgId ? (
          <Notification userId={userId} roleName={roleName} />
        ) : null}

        {data?.file && (
          <Avatar
            sx={{
              width: { xs: "30px", md: "35px" },
              height: { xs: "30px", md: "35px" },
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "#C7EEEF",
              color: "#055253",
            }}
          >
            {renderFile(data.file)}{" "}
          </Avatar>
        )}
        {data.role === 3 && !data.file ? (
          <Avatar
            sx={{
              width: { xs: "30px", md: "35px" },
              height: { xs: "30px", md: "35px" },
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "#C7EEEF",
              color: "#055253",
            }}
          >
            {data?.name?.charAt(0).toUpperCase()}
          </Avatar>
        ) : null}
        <Grid sx={{ display: { xs: "none", md: "block" } }}>
          <Typography
            sx={{
              color: "#3D3D3D",
              fontWeight: { xs: 500, md: 600 },
              fontSize: { xs: "13px", md: "14px" },
            }}
          >
            {data?.name}
          </Typography>

          <Typography
            sx={{
              color: "#3D3D3D",
              fontWeight: { xs: 300, md: 400 },
              fontSize: { xs: "12px", md: "12px" },
            }}
          >
            {roleName}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Header;
